import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOffice941ScheduleBReport extends Layout {
    checkboxIncludeSettlements: Checkbox;
    checkboxReverseVoids: Checkbox;
    office941ScheduleBDatasource: DataSource;
    textboxDateRange: Textbox;
}
